import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    uploadSkChannel = new Subject();
    detailChannel = new Subject();
    repository = new DetailRepository()
   
    constructor() {
        this.uploadSkChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchUploadSk = async (query) => {
        try {
            this.uploadSkChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUploadSk(query).then((result) => {
                this.uploadSkChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.uploadSkChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }
}

export default DetailBloc